// extracted by mini-css-extract-plugin
export var deliveryRow = "_qd-a";
export var fixedHeight = "_qd-4";
export var freightLogo = "_qd-9";
export var fullWidth = "_qd-3";
export var priceColumn = "_qd-5";
export var radioSelected = "_qd-7";
export var radioUnselected = "_qd-6";
export var selectedOption = "_qd-2";
export var selectedOptionContainer = "_qd-1";
export var selection = "_qd-0";
export var tallSkeletonText = "_qd-8";